module.exports = __webpack_public_path__ + "img/green-hairy-grass-02.21849fd2.png";